import { useEffect } from 'react';
import { motion } from 'framer-motion';
import backgroundImage from '../assets/annie-spratt-qyAka7W5uMY-unsplash.jpg';

export default function TourPackage() {
  useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);
  
  const fadeLeft = { hidden: { opacity: 0, x: -40 }, show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: 'easeOut' } } };
  const fadeRight = { hidden: { opacity: 0, x: 40 }, show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: 'easeOut' } } };

  return (
    <section className="relative py-16 min-h-screen">
      {/* Background Image with Overlay */}
      <div 
        className="fixed inset-0 -z-10"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center 30%',
          backgroundAttachment: 'fixed',
          filter: 'brightness(0.4)'
        }}
      />
      
      <div className="container relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Discover Our <span className="text-primary">Tour Packages</span></h1>
          <p className="text-xl text-white max-w-3xl mx-auto">
            Explore the world with our handpicked collection of unforgettable journeys
          </p>
        </motion.div>
      
        <div className="grid lg:grid-cols-1 gap-8 items-stretch">
          {/* <motion.div 
            variants={fadeLeft} 
            initial="hidden" 
            whileInView="show" 
            viewport={{ once: true, margin: '-80px' }} 
            className="relative rounded-2xl overflow-hidden h-[700px] shadow-2xl transform hover:scale-[1.02] transition-transform duration-500"
          >
            <img 
              src={"https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjJ8fHRyYXZlbCUyMGFnZW5jeXxlbnwwfHwwfHx8MA%3D%3D"} 
              alt="Tour Packages" 
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex items-end p-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-200 mb-2">Luxury Getaways</h2>
                <p className="text-gray-200">Experience the finest accommodations and exclusive experiences</p>
              </div>
            </div>
          </motion.div> */}

          <motion.div 
            variants={fadeRight} 
            initial="hidden" 
            whileInView="show" 
            viewport={{ once: true, margin: '-80px' }} 
            className="bg-white/60 backdrop-blur-xl rounded-2xl p-8 shadow-2xl flex flex-col gap-6 border border-white/30 shadow-lg"
          >
            <div className="space-y-4">
              <h2 className="text-3xl font-bold text-gray-800">Tailored Just For You</h2>
              <p className="text-gray-600 leading-relaxed">
                Handpicked itineraries crafted by our travel experts. From weekend getaways to multi-country adventures, we create personalized experiences that match your unique travel style, pace, and budget.
              </p>
            </div>
            
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-white/70 backdrop-blur-sm p-5 rounded-xl shadow-md border border-white/30 hover:shadow-lg transition-all duration-300 hover:bg-white/90">
                <div className="text-primary text-xl mb-2">✈️</div>
                <h3 className="font-semibold text-gray-800">Customizable Plans</h3>
                <p className="text-sm text-gray-600 mt-1">Choose dates, hotels, and activities that fit your preferences perfectly.</p>
              </div>
              
              <div className="bg-white/70 backdrop-blur-sm p-5 rounded-xl shadow-md border border-white/30 hover:shadow-lg transition-all duration-300 hover:bg-white/90">
                <div className="text-primary text-xl mb-2">💰</div>
                <h3 className="font-semibold text-gray-800">Best Price Guarantee</h3>
                <p className="text-sm text-gray-600 mt-1">Transparent quotes with zero hidden charges.</p>
              </div>
              
              <div className="bg-white/70 backdrop-blur-sm p-5 rounded-xl shadow-md border border-white/30 hover:shadow-lg transition-all duration-300 hover:bg-white/90">
                <div className="text-primary text-xl mb-2">🌍</div>
                <h3 className="font-semibold text-gray-800">Local Guides</h3>
                <p className="text-sm text-gray-600 mt-1">Trusted partners for authentic, local experiences.</p>
              </div>
              
              <div className="bg-white/70 backdrop-blur-sm p-5 rounded-xl shadow-md border border-white/30 hover:shadow-lg transition-all duration-300 hover:bg-white/90">
                <div className="text-primary text-xl mb-2">☎️</div>
                <h3 className="font-semibold text-gray-800">Phone : +9710505237316 </h3>
                <h3 className="font-semibold text-gray-800">Email : blacktech2255@gmail.com</h3>
                <p className="text-sm text-gray-600 mt-1">Dedicated support throughout your journey.</p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <motion.a 
                whileHover={{ scale: 1.03 }} 
                whileTap={{ scale: 0.98 }} 
                href="https://wa.me/9710505237316?text=Hi%20I%27m%20interested%20in%20tour%20packages" 
                target="_blank" 
                rel="noreferrer" 
                className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors inline-flex items-center justify-center gap-2"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.11.54 4.1 1.56 5.88L0 24l6.3-1.64A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.21-1.25-6.23-3.48-8.52ZM12 22a9.9 9.9 0 0 1-5.05-1.39l-.36-.21-3.6.94.96-3.5-.24-.38A9.96 9.96 0 1 1 22 12c0 5.52-4.48 10-10 10Zm5.14-7.36c-.28-.14-1.65-.81-1.9-.9s-.44-.14-.62.14c-.18.28-.71.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.43-2.24-1.38-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.12-.12.28-.32.42-.49.14-.16.18-.28.28-.46.1-.18.05-.34-.02-.49-.07-.14-.62-1.49-.85-2.05-.22-.53-.45-.46-.62-.46h-.53c-.18 0-.46.07-.7.34-.24.28-.92.9-.92 2.2 0 1.3.95 2.56 1.08 2.74.14.18 1.88 2.87 4.56 4.02.64.28 1.14.45 1.53.58.64.2 1.22.17 1.68.1.51-.08 1.65-.67 1.89-1.31.24-.64.24-1.18.17-1.31-.07-.13-.26-.2-.54-.34Z" fill="currentColor"/>
                </svg>
                <span>Chat on WhatsApp</span>
              </motion.a>
              
              {/* <motion.a 
                whileHover={{ scale: 1.03 }} 
                whileTap={{ scale: 0.98 }} 
                href="/services" 
                className="bg-white hover:bg-gray-100 text-primary border border-primary font-semibold py-3 px-6 rounded-lg transition-colors inline-flex items-center justify-center"
              >
                Explore Services
              </motion.a> */}
            </div>
          </motion.div>
        </div>
        
        {/* Additional Content Section */}
        {/* <motion.div 
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mt-16 bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-2xl"
        >
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Why Choose Our Tour Packages?</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                title: 'Expertly Curated',
                description: 'Each itinerary is carefully designed by travel experts with local knowledge.',
                icon: '✨'
              },
              {
                title: 'Flexible Options',
                description: 'Customize your trip with various accommodation and activity choices.',
                icon: '🔄'
              },
              {
                title: 'Best Value',
                description: 'Competitive pricing with premium experiences included.',
                icon: '🏆'
              }
            ].map((item, index) => (
              <div key={index} className="p-4 hover:bg-gray-50 rounded-lg transition-colors">
                <div className="text-3xl mb-3">{item.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </motion.div> */}
      </div>
    </section>
  );
}